import { Component } from "react"
import PropTypes from "prop-types"
import AttendanceDropdown from "./AttendanceDropdown"

class AttendanceDropdownContainer extends Component {
  render() {
    const {
      apiBaseUrl,
      checkInsBaseUrl,
      event,
      assignmentTypes,
      eventAttendanceReportPath,
      isSimpleEvent,
      store
    } = this.props

    return (
      <AttendanceDropdown
        attendeeCounts={store.attendeeCounts}
        eventAttendanceReportPath={eventAttendanceReportPath}
        apiBaseUrl={apiBaseUrl}
        checkInsBaseUrl={checkInsBaseUrl}
        event={event}
        assignmentTypes={assignmentTypes}
        isSimpleEvent={isSimpleEvent}
      />
    )
  }
}

AttendanceDropdownContainer.propTypes = {
  eventAttendanceReportPath: PropTypes.string,
  apiBaseUrl: PropTypes.string,
  checkInsBaseUrl: PropTypes.string,
  event: PropTypes.shape({}),
  assignmentTypes: PropTypes.array,
  isSimpleEvent: PropTypes.bool,
  store: PropTypes.shape({
    attendeeCounts: PropTypes.shape({})
  })
}

export default AttendanceDropdownContainer
